<template>
	<c-dialog ref="dialog" width="500" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id" ></c-input>
			<c-input v-if="equipmentId != 0" type="hidden" name="equipment_id" :value="equipmentId"></c-input>
			<c-form-item v-if="equipmentId == 0" label="所属机台" required>
				<c-select name="equipment_id" async @search="searchEquipment" :value-data="selectedEquipment"></c-select>
			</c-form-item>
			<c-form-item label="点位编码" required>
				<c-input type="number" name="point_code" placeholder="请输入点位编码"></c-input>
			</c-form-item>
			<c-form-item label="点位ID" tip="用于与第三方设备厂商系统对接">
				<c-input name="device_point_id" placeholder="请输入三方点位ID"></c-input>
			</c-form-item>
			<c-form-item label="状态" required>
				<c-radio-group name="state" :options="disableEnableDic"></c-radio-group>
			</c-form-item>
			<c-form-item label="备注说明">
				<c-input type="textarea" name="remark"></c-input>
			</c-form-item>
			<!--自定义字段控件-->
			<custom-form ref="customForm" work-type="71"></custom-form>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex';
	
export default {
	props: {
		equipmentId: {
			type: [Number, String],
			default: 0
		}
	},
	computed: {
		...mapState(['disableEnableDic'])
	},
	
	data() {
		return {
			editState: false,
			selectedEquipment: []
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
			this.editState = !!data;
			this.$refs.customForm.init();
			this.$refs.form.clear();
			this.selectedEquipment = [];
			
			if (data) {
				this.$refs.form.set(data);
				if (this.equipmentId == 0 && data.equipment_id && data.equipment_code) {
					this.selectedEquipment = [{
						name: data.equipment_code,
						value: data.equipment_id
					}];
				}
			} else {
				this.$refs.form.set({equipment_id: this.equipmentId || '', state: 1});
			}
			this.$refs.dialog.open({
				title: data ? '编辑点位' : '创建点位'
			});
		},

		searchEquipment(keyword, resolve){
			this.request({
				url: '/system/options',
				data: {
					options_code: 'EQUIPMENT',
					keyword: keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/equipment/point/edit':'/equipment/point/add',
				rule: {
					equipment_id: '请选择所属机台',
					point_code: '请输入点位编码',
					state: '请选择状态',
					...this.$refs.customForm.rule
				},
				dataFormatter: data => {
					if (this.equipmentId != 0) {
						data.equipment_id = this.equipmentId;
					}
					data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>
